import React from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'panamera-react-ui';

import css from './TechnicalReport.APP_TARGET.scss';
import { ADPV_EVENTS } from 'Constants/tracking';
import TechnicalTabContent from './TechnicalTabContent.APP_TARGET';

const { TabsContainer, TabContent, TabTitle } = Tabs;

export class TechnicalReport extends React.Component {
    static propTypes = {
        itemTechnicalReport: PropTypes.object.isRequired,
        itemId: PropTypes.string.isRequired,
        onTrack: PropTypes.func.isRequired
    };

    handleReportHeaderClick = key => {
        const selectedTab = this.props.itemTechnicalReport.values[key].id;

        this.props.onTrack(ADPV_EVENTS.TECHNICAL_REPORT_HEADER, {
            chosen_option: selectedTab
        });
    }

    getTabContent = () => {
        const { itemTechnicalReport, itemId, onTrack } = this.props;
        const tabContainer = [];

        if (itemTechnicalReport && itemTechnicalReport.values) {
            itemTechnicalReport.values.map(value => {
                const hasSectionValues = value && value.sections
                    && value.sections.some(section => (section.items
                        && section.items.some(item => item.values && item.values.length > 0))
                        || section.summaryText
                    );

                if (hasSectionValues) {
                    tabContainer.push(
                        <TabTitle
                            key={ `tabtitle${value.id}` }
                            className={ css.tabTitle }
                            selectedClass={ css.selected }
                            listItemClassName={ css.listElement }
                        >
                            {value.name}
                        </TabTitle>
                    );
                    tabContainer.push(
                        <TabContent className={ css.tabContent } key={ `tabcontent${value.id}` }>
                            <TechnicalTabContent
                                value={ value }
                                itemId={ itemId }
                                onTrack={ onTrack } />
                        </TabContent>
                    );
                }
            });
        }
        return tabContainer;
    }

    render() {
        const { itemTechnicalReport } = this.props;
        const tabContainer = this.getTabContent();

        return (tabContainer.length > 0
            && <React.Fragment>
                <div className={ css.technicalReportHeading }>{itemTechnicalReport.name}</div>
                <TabsContainer
                    className={ css.tabsContainer }
                    listClassName={ css.list }
                    onClick={ this.handleReportHeaderClick }
                >
                    { tabContainer }
                </TabsContainer>
            </React.Fragment>
        );
    }
}

export default TechnicalReport;
